import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Bypasses Angular's built-in sanitization for trusted HTML content.
 *
 * WARNING: Only use with trusted content from admin/host-generated sources
 * (e.g., product descriptions, event contents, blog posts).
 * Do NOT use with user-generated content (e.g., reviews, comments).
 *
 * Backend content is assumed to be validated before storage.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
